const urls = {
  auth: {
    signUp: 'auth/sign-up',
    verifyEmail: 'auth/verify-email',
    resendEmailVerification: 'auth/verify-email/resend',
    login: 'auth/login',
    logout: 'auth/logout',
    changePassword: 'auth/change-password',
    forgetPassword: 'auth/forget-password',
    resetForgottenPassword: 'auth/forget-password/reset'
  },
  profile: {
    getProfile: 'profile',
    updatePersonalInfo: 'profile/personal-info/update',
    updateContactInfo: 'profile/contact-info/update',
    updateDeliveryAddress: 'profile/delivery-address/update',
    addDeliveryAddress: 'profile/delivery-address/add',
    deleteDeliveryAddress: 'profile/delivery-address/delete',
    addLoyaltyProgram: 'profile/loyalty-program/add',
    getLoyaltyPrograms: 'profile/loyalty-program/view-all',
    updateLoyaltyProgram: 'profile/loyalty-program/update',
    deleteLoyaltyProgram: 'profile/loyalty-program/delete',
    deliveryAddress: 'profile/deliveryAddress',
    updateFirebaseUserId: 'profile/firebase/update-user-id'
  },
  flights: {
    getFlightItinerary: 'flights/itineraries/view',
    getFlightPlaces: 'flights/places',
    getCountriesAndCities: 'flights/places/countries-and-cities',
    search: 'flights/search',
    searchNext: 'flights/search/next',
    getFlightFares: 'flights/search/fare',
    getAllFlightItineraries: 'flights/itineraries/view-all',
    createFlightItinerary: 'flights/itineraries/create',
    getFlightItineraryShareLink: 'flights/itineraries/share-link',
    itineraries: 'flights/itineraries',
    getUpdatedFlightOffer: 'flights/itineraries/get-updated-flight-offer',
    cancelFlightItinerary: 'flights/itineraries/cancel',
    baggageDetails: 'flights/booking/baggage-details',
    seatDetails: 'flights/booking/seat-details',
    createFlightBooking: 'flights/booking/create',
    createExternalFlightBookingRequest: 'flights/external-flight-booking/requests/create',
    confirmExternalFlightBookingDetails: 'flights/external-flight-booking/confirm-details',
    uploadPdfFlightItinerary: 'flights/external-flight-booking/upload-pdf',
    confirmExtractedItinerary: 'flights/external-flight-booking/confirm-extracted-itinerary',
    airlines: 'flights/airlines',
    agencies: 'flights/travel-agencies',
    getAllExternalFlightBookingRequests: 'flights/external-flight-booking/requests/view-all',
    getAirportZipCode: 'flights/airport-zip-codes/:iataCode'
  },
  supportedLoyaltyPrograms: {
    getSupportedLoyaltyPrograms: 'supported-loyalty-program/view-all'
  },
  items: {
    getItemDetails: 'items/details',
    changes: 'items/changes',
    acceptItemPriceChange: 'items/price-change/accept',
    commitPurchase: 'items/commit-purchase'
  },
  publicOffers: {
    getPublicOffers: 'offers/offer-requests/view-all',
    acceptPublicOffer: 'offers/offer-requests/accept'
  },
  offers: {
    createOfferRequest: 'offers/offer-requests/create',
    viewOfferRequests: 'offers/offer-requests/view',
    acceptItemRequest: 'offers/item-requests/accept',
    denyItemRequest: 'offers/item-requests/deny',
    cancelItemRequest: 'offers/item-requests/cancel',
    resetOfferRequestFlightItinerary: 'offers/offer-requests/reset-flight-itinerary',
    releaseOfferRequest: 'offers/offer-requests/release',
    reassignItemRequest: 'offers/item-requests/reassign',
    getItemRequestTrackingDetails: 'offers/item-requests/tracking-details/get',
    updateItemRequestTrackingDetails: 'offers/item-requests/tracking-details/update',
    addItemTrackingNumber: 'offers/item-requests/external-tracking-details/add-tracking-number',
    confirmOrderDelivery: 'offers/offer-requests/:offerRequestId/confirm-delivery',
    getDeliveryCountries: 'offers/offer-requests/supported-delivery-countries'
  },
  payments: {
    createOfferRequestPaymentIntent: 'payments/payment-intents/offer-requests/create',
    createFlightBookingPaymentIntent: 'payments/payment-intents/flight-bookings/create',
    createCustomerSession: 'payments/customer-sessions/create',
    createAccountSession: 'payments/customer-sessions/account/create',
    requestOfferRequestRefund: 'payments/refunds/offer-requests/request',
    requestFlightBookingRefund: 'payments/refunds/flight-bookings/request',
    logPaymentMethodUpdate: 'payments/payment-methods/log-update',
    checkOnboardingInfo: 'payments/customer-sessions/account/check-onboarding-info',
    createExternalFlightBookingPaymentIntent: 'payments/payment-intents/external-flight-bookings/create',
    validateDiscountCode: 'payments/discount-codes/validate',
    createFulfillmentOrderPaymentIntent: 'payments/payment-intents/fulfillment-orders/create'
  },
  admin: {
    getAllUsersForAdmin: 'admin/users/view-all',
    getUserDetailsForAdmin: 'admin/users/:userId',
    getAllUserOfferRequestsForAdmin: 'admin/offer-requests/user/:userId/view-all',
    getAllOfferRequestsForAdmin: 'admin/offer-requests/view-all',
    getAllItemRequestsForAdmin: 'admin/offer-requests/:offerRequestId/item-requests/view-all',
    getOfferRequestPaymentDetailsForAdmin: 'admin/offer-requests/:offerRequestId/payment-details/view',
    getOfferRequestTripDetailsForAdmin: 'admin/offer-requests/:offerRequestId/trip-details/view',
    cancelOfferRequestForAdmin: 'admin/offer-requests/:offerRequestId/cancel',
    getUserTripsForAdmin: 'admin/trips/user/:userId',
    getAllTripsForAdmin: 'admin/trips/view-all',
    getTripDetailsForAdmin: 'admin/trips/:flightItineraryId/trip-details/view',
    getTripPaymentDetailsForAdmin: 'admin/trips/:flightItineraryId/payment-details/view',
    getTripOfferRequestDetailsForAdmin: 'admin/trips/:flightItineraryId/offer-requests/view-all',
    getAllExternalFlightBookingRequestsForAdmin: 'admin/trips/external-flight-bookings/requests/view-all',
    createItineraryFromExternalFlightBookingRequestForAdmin: 'admin/trips/external-flight-bookings/create-itinerary',
    denyExternalFlightBookingRequestForAdmin: 'admin/trips/external-flight-bookings/requests/:requestId/deny',
    updateTripDetailsForAdmin: 'admin/trips/:flightItineraryId/trip-details/update',
    getDiscountCodesForAdmin: 'admin/payments/discount-codes/view-all',
    createDiscountCodeForAdmin: 'admin/payments/discount-codes/create',
    getPurchaseReadyItems: 'admin/offer-requests/purchasable-items/view-all',
    getLockerBoxes: 'admin/lockers/boxes',
    getLockerOrders: 'admin/lockers/orders',
    getLockerMetrics: 'admin/lockers/metrics',
    getLockerOrderDetails: 'admin/lockers/boxes/:boxId/order',
    getAllFulfillmentOrdersForAdmin: 'admin/fulfillment-orders/view-all',
    getFulfillmentOrderDetailsForAdmin: 'admin/fulfillment-orders/:orderId',
    getFulfillmentOrderTripDetailsForAdmin: 'admin/fulfillment-orders/:orderId/trip-details/view'
  },
  notifications: {
    messageEmail: 'notifications/message-email'
  },
  logisticsPartner: {
    getPendingOrders: 'logistics-partner/orders/pending',
    confirmReceipt: 'logistics-partner/orders/:orderId/confirm-receipt',
    confirmTransfer: 'logistics-partner/orders/:orderId/confirm-airport-transfer',
    confirmPickup: 'logistics-partner/orders/:orderId/confirm-pickup',
    getOrderUspsLabel: 'logistics-partner/orders/:orderId/usps-label'
  },
  fulfillmentOrders: {
    getFulfillmentOrders: 'fulfillment-orders',
    getFulfillmentOrderDetails: 'fulfillment-orders/:orderId',
    createFulfillmentOrder: 'fulfillment-orders/create',
    completeDelivery: 'fulfillment-orders/:orderId/complete-delivery',
    updateUspsLocation: 'fulfillment-orders/:orderId/usps-location',
    accept: 'fulfillment-orders/:orderId/accept'
  },
  usps: {
    getLocations: 'usps/locations',
    validateAddress: 'usps/validate-address'
  }
}

export default urls
